import { render, staticRenderFns } from "./TypePrototypeFutureTable.vue?vue&type=template&id=6efd3baa&"
import script from "./TypePrototypeFutureTable.vue?vue&type=script&lang=js&"
export * from "./TypePrototypeFutureTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports